// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__2yI7H","header":"ReportDetails_header__1PMbq","title":"ReportDetails_title__3_nd3","left":"ReportDetails_left__PmPWY"};